
<b-row>
  <b-col cols="12" class="bordered">
    <b-table striped :items="value" :fields="fields" />
  </b-col>
</b-row>
